import type { IConversationalSearchStrategyData } from './types/conversational-search-srategy-data.type';


export abstract class ConversationalSearchStrategyService {
  abstract getConversationalSearchConfiguration(): IConversationalSearchStrategyData;
  abstract getConversationalSearchConfigurationForActiveTab(tabName: string): IConversationalSearchStrategyData;
}
